module.exports = __webpack_public_path__ + "img/kw.b0b93ee8.svg";